export default {
    intro: 'Hãy sắp xếp các câu bị xáo trộn theo đúng thứ tự!',
    indicator: ({ values }: { values: { isAllDone: boolean } }) => {
        const { isAllDone } = values;
        if (isAllDone) {
            return 'Hãy đọc lại bài viết đã hoàn thành.';
        }
        return 'Hãy sắp xếp thứ tự các câu cho đúng!';
    },
    retry: ({ values }: { values: { count: number } }) =>
        `Sắp đúng rồi! Còn ${values.count} câu chưa đúng vị trí. Bạn còn một lượt nữa, thử lại nhé!`,
    exhausted: 'Cùng xem đáp án nhé! Lần sau bạn sẽ làm được thôi.',
    viewCompleted: 'Xem bài đã hoàn thành',
    table: { question: 'Câu hỏi', answerRate: 'Độ chính xác', emptyMessage: 'Không có nội dung.' },
    roundNumber: 'Số {number}',
};
